import { Chip } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { colorStore } from '@/features/queueColors';

import { SelectorOption } from '../../types';

type SelectorChipProps<T = string> = {
  option: SelectorOption<T>;
  getTagProps: (props: { index: number }) => any;
  index: number;
  getOptionLabel: (option: SelectorOption<T>) => string;
};

export const SelectorChip = observer(
  <T extends string>({ option, getTagProps, index, getOptionLabel }: SelectorChipProps<T>) => {
    const color = colorStore.getColorByPrefix(option.label);
    const needsBorder = colorStore.needsBorder(option.label);
    const backgroundColorWithOpacity = color.replace('hsl(', 'hsla(').replace(')', ', 0.2)');
    const label = getOptionLabel(option);
    const truncatedLabel = label.length > 10 ? `${label.slice(0, 10)}...` : label;

    return (
      <Chip
        sx={{
          color: color,
          backgroundColor: backgroundColorWithOpacity,
          ...(needsBorder && {
            border: '1px solid rgba(0, 0, 0, 0.2)',
            textShadow: '0 0 1px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0, 0, 0, 0.5)',
          }),
        }}
        label={truncatedLabel}
        {...getTagProps({ index })}
        key={option.id}
        size="small"
      />
    );
  },
) as <T extends string>(props: SelectorChipProps<T>) => React.ReactElement;
